"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUpstreamTablesMessages = exports.getDownstreamTablesMessages = exports.getTablesMessages = exports.getAnchorCountFromConfig = exports.lineageItemKey = exports.LineageSectionType = void 0;
const catalog_messages_1 = require("@tableau/catalog-messages");
var LineageSectionType;
(function (LineageSectionType) {
    LineageSectionType[LineageSectionType["Group"] = 0] = "Group";
    LineageSectionType[LineageSectionType["Anchor"] = 1] = "Anchor";
    LineageSectionType[LineageSectionType["Owners"] = 2] = "Owners";
})(LineageSectionType = exports.LineageSectionType || (exports.LineageSectionType = {}));
function lineageItemKey(params) {
    const sectionKey = params.lineageSection.key;
    const itemKey = params.lineageItem.lineageItemType;
    return `${sectionKey}-${itemKey}`;
}
exports.lineageItemKey = lineageItemKey;
/**
 * The anchor in the lineage nav uses its own special anchorCount, but in many cases, we want it to
 * be the same as the anchor pane's count. This helper function extracts the anchor count from the
 * configuration so it can be passed into the LineageNav separately but still be defined in one place.
 */
function getAnchorCountFromConfig(config, counts) {
    const anchorSection = config.find(s => s.sectionType === LineageSectionType.Anchor);
    const anchorItem = anchorSection && anchorSection.items[0];
    return (anchorItem && counts) ? anchorItem.count(counts) : null;
}
exports.getAnchorCountFromConfig = getAnchorCountFromConfig;
function getTablesMessages(dataCloudMVPEnabled) {
    if (dataCloudMVPEnabled) {
        return {
            withCount: catalog_messages_1.Messages.TablesAndObjectsWithCount,
            withoutCount: catalog_messages_1.Messages.TablesAndObjects,
        };
    }
    else {
        return {
            withCount: catalog_messages_1.Messages.TablesWithCount,
            withoutCount: catalog_messages_1.Messages.Tables,
        };
    }
}
exports.getTablesMessages = getTablesMessages;
function getDownstreamTablesMessages(dataCloudMVPEnabled) {
    if (dataCloudMVPEnabled) {
        return {
            withCount: catalog_messages_1.Messages.DownstreamTablesAndObjectsWithCount,
            withoutCount: catalog_messages_1.Messages.DownstreamTablesAndObjects,
        };
    }
    else {
        return {
            withCount: catalog_messages_1.Messages.DownstreamTablesWithCount,
            withoutCount: catalog_messages_1.Messages.DownstreamTables,
        };
    }
}
exports.getDownstreamTablesMessages = getDownstreamTablesMessages;
function getUpstreamTablesMessages(dataCloudMVPEnabled) {
    if (dataCloudMVPEnabled) {
        return {
            withCount: catalog_messages_1.Messages.UpstreamTablesAndObjectsWithCount,
            withoutCount: catalog_messages_1.Messages.UpstreamTablesAndObjects,
        };
    }
    else {
        return {
            withCount: catalog_messages_1.Messages.UpstreamTablesWithCount,
            withoutCount: catalog_messages_1.Messages.UpstreamTables,
        };
    }
}
exports.getUpstreamTablesMessages = getUpstreamTablesMessages;
//# sourceMappingURL=LineageConfiguration.js.map